import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AuthLayout } from '../../app/AuthLayout';
import { Alert, Spinner } from '../../ui/Feedback';
import { useDocumentTitle, useStrings } from '../../tenant/TenantProvider';
import { apiRequest } from '../../lib/api';

const requests = new Map();

function verify(token) {
  if (!requests.has(token)) {
    requests.set(token, apiRequest(`/auth/verify-email?token=${encodeURIComponent(token)}`));
  }
  return requests.get(token);
}

export function VerifyEmailPage() {
  const t = useStrings();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');
  const [failed, setFailed] = useState(!token);

  useDocumentTitle(t('auth.verification.title'));

  useEffect(() => {
    if (!token) return undefined;
    let cancelled = false;
    verify(token).then((response) => {
      if (cancelled) return;
      if (response.success) {
        navigate('/login', { replace: true, state: { notice: { tone: 'success', message: t('auth.verification.success') } } });
      } else {
        setFailed(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [token, navigate, t]);

  return (
    <AuthLayout
      title={t('auth.verification.title')}
      footer={
        <Link to="/login" className="text-link">
          {t('auth.backToSignIn')}
        </Link>
      }
    >
      {failed ? (
        <Alert tone="danger">{t(token ? 'auth.verification.invalid-token' : 'auth.verification.missing-token')}</Alert>
      ) : (
        <div className="auth__loading">
          <Spinner label={t('auth.verification.checking')} />
        </div>
      )}
    </AuthLayout>
  );
}
